var exports = {
  "k": "x93eb46d8--0c4d89--container",
};

module.exports = exports;
